import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const initials = (n = "") => n.replace(/[[\]]/g, "").split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase() || "ST";

const Card = ({ t, i }) => (
  <Reveal delay={i * 0.1} className="h-full">
    <motion.figure whileHover={{ y: -6, rotate: i % 2 ? 0.6 : -0.6 }} transition={{ type: "spring", stiffness: 260, damping: 20 }} data-testid={`testimonial-card-${i}`} className="relative flex h-full flex-col rounded-3xl border border-slate-200 bg-white p-8 shadow-[0_20px_60px_-30px_rgba(15,23,42,0.25)]">
      <Quote className="absolute right-6 top-6 h-10 w-10 text-blue-100" />
      <div className="flex gap-1" aria-label={`${t.rating ?? 5} stars`}>
        {Array.from({ length: t.rating ?? 5 }, (_, k) => <Star key={k} className="h-5 w-5 fill-[#FACC15] text-[#FACC15]" />)}
      </div>
      <blockquote className="mt-5 flex-1 text-base leading-relaxed text-slate-700 md:text-lg">“{t.quote}”</blockquote>
      <figcaption className="mt-8 flex items-center gap-3 border-t border-slate-200 pt-6">
        {t.image ? (
          <img src={t.image} alt={t.name} loading="lazy" data-testid={`testimonial-image-${i}`} className="h-14 w-14 rounded-full object-cover ring-4 ring-blue-100" />
        ) : (
          <span className="font-display flex h-14 w-14 items-center justify-center rounded-full bg-blue-600 text-sm font-bold text-white">{initials(t.name)}</span>
        )}
        <span><span className="block font-bold text-slate-900" data-testid={`testimonial-name-display-${i}`}>{t.name}</span>{t.role && <span className="block text-sm text-slate-600">{t.role}</span>}</span>
      </figcaption>
    </motion.figure>
  </Reveal>
);

export const Testimonials = ({ s }) => {
  const list = Array.isArray(s?.testimonials) ? s.testimonials : [];
  if (!list.length) return null;
  return (
    <section id="testimonials" className="relative mx-auto max-w-7xl px-5 py-28 lg:px-8 lg:py-36" data-testid="testimonials-section">
      <Reveal className="max-w-3xl">
        <Eyebrow>Testimonials</Eyebrow>
        <h2 className="font-display mt-6 text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-4xl">What our customers <span className="text-gradient">are saying.</span></h2>
      </Reveal>
      <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {list.map((t, i) => <Card key={i} t={t} i={i} />)}
      </div>
    </section>
  );
};
